import {
  Control,
  Controller,
  FieldValues,
  get,
  Path,
  PathValue,
  useFormState,
} from 'react-hook-form';
import ControllerCheckboxGroup from '../ui/ControllerCheckboxGroup';
import clsx from 'clsx';
import { type LabelValue } from '@/types/global';

interface StyledRCheckboxGroupProps<FieldsType extends FieldValues> {
  control: Control<FieldsType>;
  name: Path<FieldsType>;
  options: Array<LabelValue<string>>;
  className?: React.HTMLAttributes<HTMLDivElement>['className'];
  disabled?: boolean;
  displayInColumns?: boolean;
  displayAllOption?: boolean;
  isViewMode?: boolean;
}

const StyledCheckboxGroup = <FieldsType extends FieldValues>({
  control,
  name,
  className,
  options,
  displayInColumns = false,
  displayAllOption = true,
  isViewMode = false,
}: StyledRCheckboxGroupProps<FieldsType>) => {
  const { errors } = useFormState({ control });
  const errorMessage = get(errors, name + '.message') as unknown as string;
  return (
    <div className={clsx('flex flex-col w-full gap-1.5', className)}>
      <Controller
        control={control}
        name={name}
        render={({ field }) => {
          field.value =
            field.value ?? ([] as PathValue<FieldsType, Path<FieldsType>>);
          return (
            <ControllerCheckboxGroup
              field={field}
              options={options}
              isViewMode={isViewMode}
              displayInColumns={displayInColumns}
              displayAllOption={displayAllOption}
            />
          );
        }}
      />
      {errorMessage !== '' && (
        <p className="text-sm leading-6 font-medium text-error-500">
          {errorMessage}
        </p>
      )}
    </div>
  );
};

export default StyledCheckboxGroup;
